import { COLOR_OPTIONS } from "../constants/index.js";
export const getRandomColor = (excludedColors = []) => {
    // Get all keys from the COLOR_OPTIONS object.
    const colorKeys = Object.keys(COLOR_OPTIONS);
    const filteredKeys = colorKeys.filter((key) => !excludedColors.includes(key));
    // Generate a random index based on the length of the filtered array.
    const randomIndex = Math.floor(Math.random() * filteredKeys.length);
    // Get the random key from the filtered array.
    const randomKey = filteredKeys[randomIndex];
    // Return the COLOR_OPTION object corresponding to the random key.
    return COLOR_OPTIONS[randomKey];
};
//# sourceMappingURL=color.js.map